export default "__VITE_ASSET__B_yBl7pB__"